var setPmarkCounter = function() {
    var delayTime = 5000;
    $('.body-use-of-personal-information h2').eq(0).css({
        padding: 0,
        margin : 0,
        color  : '#777',
        fontSize: '1.2em'
    });

    var pmarkMsg = $('<div style="margin: 0 0 16px 0; font-size: 0.9em;">こちらは、JIS Q 15001（プライバシーマーク）のガイドラインに基づいて表示しています。</div>');
    $('.body-use-of-personal-information').prepend(pmarkMsg);

    $('.body-use-of-personal-information').show();
    var heightOrg = $('.body-use-of-personal-information').css('height');
    $('.body-use-of-personal-information').css('height', '180px');
    setTimeout((function() {
        $('.body-use-of-personal-information').animate({
            height: heightOrg
        }, 500)
    }), delayTime - 300);

    var time = delayTime;
    var timerMsg = $('<div class="time-msg">'
                 + 'あと<span class="time-msg-sec" style="font-size: 1.2em; padding: 0 4px;">' + (time / 1000) + '</span>秒で全文を表示します<br>'
                 + '<span style="text-align: center; font-size: 0.9em;">（JIS Q 15001のガイドラインに基づいて表示しています）</span>'
                 + '</div>');
    timerMsg.css({
        'position'        : 'absolute',
        'color'           : '#fff',
        'background-color': 'rgba(100, 100, 100, 0.8)',
        'width'           : '250px',
        'padding'         : '8px',
        'text-align'      : 'center',
        'top'             : '50px',
        'right'           : '0',
        'left'            : '0',
        'margin'          : 'auto'
    });
    $('.body-use-of-personal-information').prepend(timerMsg);
    var intervalId = setInterval((function() {
        time = time - 1000;
        if (time <= 0) {
            clearInterval(intervalId);
            $('.time-msg').hide();
        }
        var sec = (time / 1000);
        $('.time-msg-sec').text(sec);
    }), 1000);
}

$(function() {
    var winHeight = $(window).height();
    if ($('.body-use-of-personal-information').offset().top < winHeight) {
        setPmarkCounter();
    }
    else {
        flagSet = false;
        $(window).scroll(function(){
            var winScroll = $(window).scrollTop();
            var scrollPos = winScroll + winHeight;
            if ($('.body-use-of-personal-information').offset().top < scrollPos && flagSet === false) {
                setPmarkCounter();
                flagSet = true;
            }
        })
    }
});
